module.exports = __webpack_public_path__ + "img/Marsha_Headshot-photoaidcom-cropped.e78d56b7.JPG";